import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

const HomePage = () => {
  useEffect(() => {
    // Add Schema.org JSON-LD for Local Business
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BeautySalon",
      "name": "GOLDEN MOUNTAIN spa",
      "description": "Professional SPA wellness center offering Thai massage, Moroccan bath, jacuzzi massage and more",
      "url": "https://www.goldenmoiutainspa.com",
      "telephone": "0509348676",
      "email": "info@jingxinspa.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Oasis Tower 1, Shop Number 3",
        "addressLocality": "Sport City",
        "addressRegion": "Dubai",
        "addressCountry": "AE"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "25.0420",
        "longitude": "55.2208"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          "opens": "11:00",
          "closes": "03:00"
        }
      ],
      "priceRange": "170-300 AED"
    });
    document.head.appendChild(script);

    return () => {
      try {
        if (script.parentNode) {
          document.head.removeChild(script);
        }
      } catch (error) {
        console.warn('Failed to remove JSON-LD script:', error);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
